// News&Magazine
import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  Button,
  Table,
  Form,
  CloseButton,
  Pagination,
  Tab,
  Tabs,
} from "react-bootstrap";
import { FaFileAlt } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";

import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDropzone } from "react-dropzone";
import "react-quill/dist/quill.snow.css";
import {
  MdKeyboardArrowRight,
  MdKeyboardArrowLeft,
  MdKeyboardDoubleArrowRight,
  MdKeyboardDoubleArrowLeft,
} from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { FaEdit, FaPlus } from "react-icons/fa";
import axios from "axios";
import CustomAlert from "../CustomAlert/CustomAlert";
import "bootstrap/dist/css/bootstrap.min.css";
import ConfirmationMessage from "../ConfirmationMessage/ConfirmationMessage";
import { urlApi } from "../../App";
import { FaTimes } from "react-icons/fa";


const NewsMagazine = () => {
  const currentDate = new Date().toISOString().split("T")[0];
  const [annoucement, setannoucement] = useState([]);
  const [title, setTitle] = useState("");
  const [desc, setdesc] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [code, setCode] = useState("");

  const [configlov, setconfiglov] = useState("");
  const [bulletInList, setBulletInList] = useState("");
  const [annoucementType, setAnnoucementType] = useState(null);
  const [categoryValue, setCategoryValue] = useState(null);
  const [bulletInId, setBulletInId] = useState(null);
  const [statusId, setStatusId] = useState("");
  const [lovtype, setLovType] = useState("");
  const [lovstatus, setLovStatus] = useState("");
  const [category, setCategory] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertCallback, setAlertCallback] = useState(null);
  const [editorContent, setEditorContent] = useState("");
  const indexOfLastEntry = currentPage * 15;
  const indexOfFirstEntry = indexOfLastEntry - 15;
  const totalPages = Math.ceil(annoucement.length / 15);
  const currentEntries = annoucement.slice(
    indexOfFirstEntry,
    indexOfLastEntry
  );
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const [codeError, setCodeError] = useState("");
  const [anncoumentTypeError, setanncoumentTypeError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [statusError, setstatusError] = useState("");
  const [titleError, setTitleError] = useState("");
  const [msgError, setMsgError] = useState("");
  const [startDateError, setStartDateError] = useState("");
  const [endDateError, setEndDateError] = useState("");
  const [file, setFile] = useState([]); // Initialize as an empty array
  const [existingFiles, setExistingFiles] = useState([]);
  const [enableId, setEnableId] = useState(false);
  // handle image in editor
  const [content, setContent] = useState("");
  const [error, setError] = useState("");

  const imageLimit = 3;
  // end image handle in editor. 
  const editorRef = useRef(null);
  useEffect(() => {
    
    AnnoucementType();
    categoryType();
    status();
    bulletIn();
    fetchData();
  }, []);
  const AnnoucementType = async () => {
    try {
      const vtype = 'ANTP';
      
      const response = await axios.get(`${urlApi}/api/v1/lovtypes/${vtype}`);
      console.log(response.data);
      setLovType(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  // console.log(existingFiles, "existingFiles")
  const handleOpenDriveFile = (file) => {
    const fileUrl = `https://drive.google.com/uc?export=view&id=${file.driveid}`;
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  const status = async () => {
    try {
      const vtype = 'SDP';
      
      const response = await axios.get(`${urlApi}/api/v1/lovtypes/${vtype}`);
      console.log(response.data);
      setLovStatus(response.data);
    } catch (error) {
      console.log(error);
    }
  }
  const bulletIn = async () => {
    try {
      const vtype = 'BLT';
      
      const response = await axios.get(`${urlApi}/api/v1/lovtypes/${vtype}`);
      console.log(response.data);
      setBulletInList(response.data);
    } catch (error) {
      console.log(error);
    }
  }
  const categoryType = async () => {
    try {
      const response = await axios.get(`${urlApi}/api/v1/mobmenu`);
      console.log(response.data);
      setCategory(response.data);
    } catch (error) {
      console.log(error);
    }
  }
  const fetchData = async () => {
    try {
      const districtQuotaResponse = await axios.get(
        `${urlApi}/api/v1/newsannoucement`
      );
      const formattedannoucement = districtQuotaResponse.data.map(
        (element) => {
          let startdate = new Date(element.startdate);
          let enddate = new Date(element.enddate);
          startdate = new Date(startdate.getTime() + Math.abs(startdate.getTimezoneOffset() * 60000));
          enddate = new Date(enddate.getTime() + Math.abs(enddate.getTimezoneOffset() * 60000));

          return {
            ...element,
            startdate: startdate.toISOString().split("T")[0],
            enddate: enddate.toISOString().split("T")[0],
          };
        }
      );
      setannoucement(formattedannoucement);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const addDataToTable = async () => {
    if (!validateForm()) {
      return;
    };
    debugger
    console.log(file, existingFiles, "files")
    const delta = editorRef.current.getEditor().getContents()?.ops;
    const plainText = editorRef.current.getEditor().getText();
    const newData = {
      typeid: code,
      stxt: title,
      statusid: statusId,
      docmentid: annoucementType,
      ltxt: editorContent,
      startdate: startDate,
      enddate: endDate,
      description: desc,
      deltaltxt: JSON.stringify(delta),
      plainltxt: plainText,
      categoryId: categoryValue,
      bulletinId: bulletInId,
    };

    try {
      if (selectedIndex !== null) {
        await axios.put(
          `${urlApi}/api/v1/newsannoucement/${annoucement[selectedIndex].id}`,
          newData
        );
        handleFileUpload(annoucement[selectedIndex].id);
        showAlertWithAutoDismiss("Record updated successfully.");
      } else {
        const postResponse = await axios.post(`${urlApi}/api/v1/newsannoucement`, newData);

        console.log("Post Response:", postResponse.data);
        showAlertWithAutoDismiss("Record saved successfully.");

        // Use postResponse.data.id to pass as modelid to file upload
        const modelid = postResponse.data.id;
        handleFileUpload(modelid); // Pass modelid to the file upload handler
      }

      clearModalFields();
      await fetchData();
      handleCloseModal();
    } catch (error) {
      console.error("Error adding/updating data:", error);
    }
  };
  const deleteDataFromTable = async (id) => {
    setDeleteId(id);
    setShowConfirmation(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`${urlApi}/api/v1/newsannoucement/${deleteId}`);
      fetchData();
      showAlertWithAutoDismiss("  successfully deleted.");
    } catch (error) {
      console.error("Error deleting News & Annoucement:", error);
    }
    setShowConfirmation(false);
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
    setDeleteId(null);
  };

  const handleShowModal = () => {
    setShowModal(true);

  };

  const handleCloseModal = () => {
    setShowModal(false);
    clearModalFields();
  };

  // const openUpdateModal = async (index) => {
  //   
  //   const cumulativeIndex = indexOfFirstEntry + index;
  //   const data = annoucement[cumulativeIndex];
  //   setCode(data.typeid);
  //   setTitle(data.stxt);
  //   setStartDate(data.startdate);
  //   setEndDate(data.enddate);
  //   setEditorContent(data.ltxt);
  //   setAnnoucementType(data.docmentid);
  //   setStatusId(data.statusid);
  //   setSelectedIndex(cumulativeIndex);
  //   handleShowModal();
  // };

  const openUpdateModal = async (index) => {
    debugger
    const cumulativeIndex = indexOfFirstEntry + index;
    const data = annoucement[cumulativeIndex];

    // Ensure the selectedModelid is properly set
    const selectedModelid = data.id; // Define selectedModelid here
    try {
      const response = await axios.get(`${urlApi}/attachments/${selectedModelid}`);
      console.log(response.data); // Logs the fetched attachment data
      setExistingFiles(response.data); // Store the existing files
    } catch (error) {
      console.log(error);
      setExistingFiles([]); // Clear files if an error occurs
    }
    // Setting the modal fields
    setCode(data.typeid);
    setTitle(data.stxt);
    setdesc(data.description);
    setStartDate(data.startdate);
    setEndDate(data.enddate);
    setEditorContent(data.ltxt);
    setAnnoucementType(data.docmentid);
    setCategoryValue(data.categoryId);
    setStatusId(data.statusid);
    setSelectedIndex(cumulativeIndex);
    setBulletInId(data.bulletinId)
    setEnableId(true)

    handleShowModal(); // Open the modal
  };


  const clearModalFields = () => {
    setCode("");
    setdesc("");
    setTitle("");
    setStartDate("");
    setEndDate("");
    setSelectedIndex(null);
    setCodeError("");
    setanncoumentTypeError("");
    setCategoryError("")
    setstatusError("");
    setEditorContent("");
    setStatusId(null);
    setAnnoucementType(null);
    setTitleError("");
    setMsgError("");
    setStartDateError("");
    setEndDateError("");
    setFile([]);
    setExistingFiles("");
    setCategoryValue("");
    setBulletInId("");
    setEnableId(false)
  };

  const validateForm = () => {
    let isValid = true;

    if (!code || !code.trim()) {
      setCodeError("Announcement ID is required");
      isValid = false;
    } else {
      setCodeError("");
    }

    if (!annoucementType) {
      setanncoumentTypeError("Announcement Type is required");
      isValid = false;
    } else {
      setanncoumentTypeError("");
    }

    if (!categoryValue) {
      setCategoryError("Category is required");
      isValid = false;
    } else {
      setCategoryError("");
    }

    if (!statusId) {
      setstatusError("Status is required");
      isValid = false;
    } else {
      setstatusError("");
    }

    if (!title || !title.trim()) {
      setTitleError("Title is required");
      isValid = false;
    } else {
      setTitleError("");
    }

    if (!desc || !desc.trim()) {
      setMsgError("Message is required");
      isValid = false;
    } else {
      setMsgError("");
    }

    if (!startDate || !startDate.trim()) {
      setStartDateError("Start Date is required");
      isValid = false;
    } else {
      setStartDateError("");
    }

    if (!endDate || !endDate.trim()) {
      setEndDateError("End Date is required");
      isValid = false;
    } else {
      setEndDateError("");

      if (startDate && endDate) {
        const startDateObj = new Date(startDate);
        const endDateObj = new Date(endDate);
        if (endDateObj < startDateObj) {
          setEndDateError("End Date can't be less than Start Date");
          isValid = false;
        } else {
          setEndDateError("");
        }
      }
    }

    return isValid;
  };


  const handleAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    if (alertCallback) {
      alertCallback();
    }
    // setAutoDismiss(false);
  };

  const showAlertMessage = (message, callback = null, dismissAfter = null) => {
    setAlertMessage(message);
    setAlertCallback(callback);
    setShowAlert(true);
    if (dismissAfter) {
      setTimeout(() => {
        handleAlertClose();
      }, dismissAfter);
    }
  };

  const showAlertWithAutoDismiss = (message) => {
    showAlertMessage(message, null, 2000);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value));
    setCurrentPage(1);
  };


  useEffect(() => {
    const handleInputChange = function () {
      const searchTerm = this.value.toLowerCase();
      const columnIndex = this.parentElement.cellIndex;
      const table = document.querySelector(".table-container");
      const rows = table.querySelectorAll("tbody tr");

      rows.forEach(function (row) {
        const cellValue = row.cells[columnIndex].textContent.toLowerCase();

        if (cellValue.includes(searchTerm)) {
          row.style.display = "";
        } else {
          row.style.display = "none";
        }
      });
    };

    const searchInputs = document.querySelectorAll(".table-filter");

    searchInputs.forEach(function (input) {
      input.addEventListener("input", handleInputChange);
    });

    return () => {
      searchInputs.forEach(function (input) {
        input.removeEventListener("input", handleInputChange);
      });
    };
  }, []);
  const handleSelectChange = (e) => {
    setAnnoucementType(e.target.value);
    setFile([])
  };
  const handleCategoryType = (e) => {
    setCategoryValue(e.target.value);
  };
  const handleStatusChange = (e) => {
    setStatusId(e.target.value);
  };
  const handleBulletInChange = (e) => {
    setBulletInId(e.target.value);
  };

  const handleRichTextbox = (value) => {
    setEditorContent(value);
    
    handleContentChange(editorContent);
  };

  const handleContentChange = (value) => {
    
    const parser = new DOMParser();
    const doc = parser.parseFromString(value, "text/html");
    const imageCount = doc.querySelectorAll("img").length;
    if (imageCount > imageLimit) {
      console.log("You can only upload up to 5 images.");
      setError(`You can only upload up to ${imageLimit} images.`);
    } else {
      setError(""); 
      setContent(value); 
    }
  };
  
  const handleDelete = async (id) => {
    try {
      // Call the API to delete the file
      const response = await axios.delete(`${urlApi}/attachments/${id}`);
      console.log(response.data.message);

      // Update the file list in the UI
      setExistingFiles((prevFiles) =>
        prevFiles.filter((file) => file.id !== id)
      );
    } catch (error) {
      console.error("Error deleting file:", error.response?.data || error);
    }
  };
  const imageHandler = () => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      if (file) {
        const formData = new FormData();
        formData.append('image', file);

        try {
          // Call your backend API to upload the image
          const response = await fetch('/upload', {
            method: 'POST',
            body: formData,
          });
          const data = await response.json();

          // Insert uploaded image URL into the editor
          const editor = editorRef.current.getEditor();
          const range = editor.getSelection();
          editor.insertEmbed(range.index, 'image', data.imageUrl);
        } catch (error) {
          console.error('Image upload failed:', error);
        }
      }
    };
  };

  // working code for  uploading
  // const handleFileUpload = async (modelid) => {
  //   if (!modelid) {
  //     console.error("modelid is not provided.");
  //     return;
  //   }

  //   if (file.length === 0) {
  //     console.log("No files selected.");
  //     return;
  //   }
  //   if (existingFiles.length == 1) {
  //     
  //     showAlertWithAutoDismiss("Don't save another files");
  //     return
  //   }
  //   
  //   if (annoucementType == 6 && file.length !== 1) {
  //     if (existingFiles.length == 1) {
  //       showAlertWithAutoDismiss("Don't save another files");
  //       return
  //     }
  //     return;
  //   }


  //   if (annoucementType == 15) {
  //     // if (file.length !== 2) {
  //     //   console.error("For announcementType 15, exactly two files are required.");
  //     //   alert("For announcementType 15, exactly two files are required.");
  //     //   return;
  //     // }

  //     // Check if files are image and PDF
  //     const imageFile = file.find(f => f.type.startsWith("image"));
  //     const pdfFile = file.find(f => f.type === "application/pdf");

  //     // if (!imageFile || !pdfFile) {
  //     //   alert("For announcementType 15, one image and one PDF file are required.")
  //     //   console.error("For announcementType 15, one image and one PDF file are required.");
  //     //   return;
  //     // }
  //   }

  //   const uploading = new FormData();
  //   file.forEach((fileItem) => {
  //     uploading.append("files", fileItem);
  //   });

  //   uploading.append("modelid", modelid); // Append modelid to FormData

  //   try {
  //     // Make the API request to upload files
  //     const response = await axios.post(`${urlApi}/api/v1/uploading`, uploading, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });

  //     console.log("Upload response:", response.data);
  //     setFile([]); // Clear the selected files after successful upload

  //     // Re-fetch and update existing files after upload
  //     await fetchAttachments(modelid);
  //   } catch (error) {
  //     console.error("Upload error:", error.response?.data || error.message);
  //   }
  // };
  // const fetchAttachments = async (modelid) => {
  //   try {
  //     const response = await axios.get(`${urlApi}/attachments/${modelid}`);
  //     console.log(response.data);
  //     setExistingFiles(response.data); // Update the existing files state
  //   } catch (error) {
  //     console.error("Error fetching attachments:", error);
  //     setExistingFiles([]); // Clear files in case of error
  //   }
  // };
  // end uploading 

  const handleFileUpload = async (modelid) => {
    if (!modelid) {
      console.error("modelid is not provided.");
      return;
    }
  
    if (file.length === 0) {
      console.log("No files selected.");
      return;
    }
       
    if (annoucementType == 6) {
      debugger
      // Allow only one image for annoucementType 6
      const existingImage = existingFiles.find(
        (f) => f.filetype && f.filetype.startsWith("image") // Check if type exists before calling startsWith
      );
      if (existingImage) {
        showAlertWithAutoDismiss("Only one image can be uploaded for this announcement type.");
        return;
      }
  
      const newImage = file.find((f) => f.type && f.type.startsWith("image")); // Validate type
      if (!newImage) {
        showAlertWithAutoDismiss("Only image files are allowed for this announcement type.");
        return;
      }
    }
  
    if (annoucementType == 15) {
      // Allow one image and one PDF for annoucementType 15
      const existingImage = existingFiles.find(
        (f) => f.filetype && f.filetype.startsWith("image") // Check if type exists before calling startsWith
      );
      const existingPdf = existingFiles.find(
        (f) => f.filetype === "application/pdf" // Validate type
      );
  
      const newImage = file.find((f) => f.type && f.type.startsWith("image")); // Validate type
      const newPdf = file.find((f) => f.type === "application/pdf"); // Validate type
  
      if (existingImage && newImage) {
        showAlertWithAutoDismiss("An image is already uploaded. Only one image is allowed.");
        return;
      }
  
      if (existingPdf && newPdf) {
        showAlertWithAutoDismiss("A PDF is already uploaded. Only one PDF is allowed.");
        return;
      }
  
      if (!newImage && !newPdf) {
        showAlertWithAutoDismiss("Please upload one image and one PDF only.");
        return;
      }
    }
  
    // Proceed with the file upload
    const uploading = new FormData();
    file.forEach((fileItem) => {
      uploading.append("files", fileItem);
    });
  
    uploading.append("modelid", modelid); // Append modelid to FormData
  
    try {
      // Make the API request to upload files
      const response = await axios.post(`${urlApi}/api/v1/uploading`, uploading, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      console.log("Upload response:", response.data);
      setFile([]);

      await fetchAttachments(modelid);
    } catch (error) {
      console.error("Upload error:", error.response?.data || error.message);
    }
  };
  
  const fetchAttachments = async (modelid) => {
    try {
      const response = await axios.get(`${urlApi}/attachments/${modelid}`);
      console.log(response.data);
      setExistingFiles(response.data); 
    } catch (error) {
      console.error("Error fetching attachments:", error);
      setExistingFiles([]); 
    }
  };
  
  const Font = Quill.import("formats/font");
  Font.whitelist = ["default", "serif", "monospace", "urdu"];
  Quill.register(Font, true);


  // const onDrop = (acceptedFiles, rejectedFiles) => {
    
  //   if (rejectedFiles.length > 0) {
  //     console.warn("Some files were rejected:", rejectedFiles);
  //     return;
  //   }

  //   if (!annoucementType) {
  //     console.warn("Invalid announcement type. No files can be selected.");
  //     return;
  //   }

  //   if (annoucementType == 6) {
      
  //     console.log(file);
  //     if (existingFiles.length > 1) {
  //       showAlertWithAutoDismiss("Don't add another files");
  //       setFile([])
  //       return;
  //     }
  //   }

  //   if (acceptedFiles.length > 0) {
  //     if (annoucementType == 6) {

  //       const isSingleImage = acceptedFiles.length == 1 && acceptedFiles[0].type.startsWith("image");
  //       if (isSingleImage) {
  //         setFile(acceptedFiles);
  //       } else {
  //         console.warn("Only one image file is allowed.");
  //       }

  //     }
  //     else if (annoucementType == 15) {
        
  //       const images = acceptedFiles.filter((file) => file.type.startsWith("image"));
  //       const pdfs = acceptedFiles.filter((file) => file.type === "application/pdf");
        

  //       if (images) {
          
  //       }
  //       setFile((prevFiles) => [...prevFiles, ...acceptedFiles]);

  //     }
  //   }
  // };


  // if (images) {
  //   setFile(acceptedFiles); // Replace the file list with the new file
  // } else {
  //   console.warn("Only one image file is allowed.");
  // }
  // if (pdfs.length === 0) {
  //   console.warn("A PDF file is required.");
  //   return;
  // }
  // if (images) {
  //   setFile(acceptedFiles);
  // } else {
  //   console.warn("Only one image file is allowed.");
  // }
  // if (images.length !== 1 || pdfs.length !== 1) {
  //   console.warn("Only one image file is allowed.");
  //   return;
  // }

  // if (pdfs.length !== 1) {
  //   console.warn("Only one PDF file is allowed.");
  //   return;
  // }


  const onDrop = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length > 0) {
      console.warn("Some files were rejected:", rejectedFiles);
      return;
    }
  
    if (!annoucementType) {
      console.warn("Invalid announcement type. No files can be selected.");
      return;
    }
  
    if (annoucementType == 6) {
      if (acceptedFiles.length !== 1 || !acceptedFiles[0].type.startsWith("image/")) {
        showAlertWithAutoDismiss("Only one image is allowed.");
        return;
      }
  
      // Replace existing files with the new one
      setFile(acceptedFiles);
    } else if (annoucementType == 15) {
      const images = acceptedFiles.filter((file) => file.type.startsWith("image/"));
      const pdfs = acceptedFiles.filter((file) => file.type === "application/pdf");
  
      // Validate the file selection for type 15
      if (images.length > 1 || pdfs.length > 1 || images.length + pdfs.length > 2) {
        showAlertWithAutoDismiss("Only one image and one PDF are allowed.");
        return;
      }
  
      // Combine the files, ensuring no duplicates
      const newFiles = [...images, ...pdfs];
      setFile((prevFiles) => {
        const allFiles = [...prevFiles, ...newFiles];
        const uniqueFiles = allFiles.filter(
          (file, index, self) =>
            index === self.findIndex((f) => f.name === file.name && f.type === file.type)
        );
  
        // Ensure there is only one image and one PDF
        const finalImages = uniqueFiles.filter((file) => file.type.startsWith("image/")).slice(0, 1);
        const finalPdfs = uniqueFiles.filter((file) => file.type === "application/pdf").slice(0, 1);
  
        return [...finalImages, ...finalPdfs];
      });
    }
  };
  
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
    accept:
      annoucementType == 6
        ? { "image/*": [] }
        : annoucementType == 15
          ? { "image/*": [], "application/pdf": [] }
          : null,
    onDragEnter: (event) => {
      console.log("Drag entered:", event);
    },
    onDragReject: (event) => {
      console.warn("Drag rejected:", event);
    },
    disabled: !annoucementType,
  });

  console.log(file, annoucementType, "File Uploading Document")
  // end drag and drop
  return (
    <div id="district_Quota" className="container-fluid mt-4">
      <hr />
      <div className="new_pagin">
        <div className="addingButton">
          <button onClick={handleShowModal}>
            <FaPlus
              style={{
                color: "#00483f",
                fontSize: "10px",
                marginBottom: "1px",
              }}
            />
            <span>New</span>
          </button>
        </div>

        <CustomAlert
          message={alertMessage}
          show={showAlert}
          onClose={handleAlertClose}
        />
        <ConfirmationMessage
          message="Are you sure you want to delete this record?"
          show={showConfirmation}
          onCancel={handleCloseConfirmation}
          onConfirm={confirmDelete}
        />
        <div className="btnPagDrp">
          <Pagination className="pagination">
            <Pagination.First
              className="bgc ldarrow"
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
            >
              <MdKeyboardDoubleArrowLeft />
            </Pagination.First>
            <Pagination.Prev
              className="bgc larrow"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <MdKeyboardArrowLeft />
            </Pagination.Prev>
            <Pagination.Item disabled>
              {`Page: ${currentPage} of ${totalPages}`}
            </Pagination.Item>
            <Pagination.Next
              className="bgc rarrow"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              <MdKeyboardArrowRight />
            </Pagination.Next>
            <Pagination.Last
              className="bgc rddarrow"
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
            >
              <MdKeyboardDoubleArrowRight />
            </Pagination.Last>
          </Pagination>
          <Form.Select
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
            className="rowperpage"
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </Form.Select>
        </div>
      </div>

      <div id="complete_modal" className="complete_modal">
        <Modal show={showModal} onHide={handleCloseModal} backdrop="static">
          <div className="modal_header">
            <div className="modal_heading">
              <Modal.Title>
                <span>Publish Document</span>
              </Modal.Title>
            </div>
            <div className="closeicon">
              <CloseButton
                variant="white"
                className="bn_close"
                onClick={handleCloseModal}
              />
            </div>
          </div>

          <div className="line"></div>

          <Modal.Body>
            <Form>
              <div className="districtQuota">
                <div className="comboflex">
                  <div className="districtQuota1">
                    <Form.Group className="mb-2" controlId="city_code">
                      <Form.Label className="formlabel">
                        <span>
                          Code<span className="mandatoryField">*</span>
                        </span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Code"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        isInvalid={!!codeError}
                      />
                      <Form.Control.Feedback type="invalid">
                        {codeError}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="approval_fields1">
                    <Form.Group className="mb-2" controlId="NOC_Approval_Status">
                      <Form.Label className="formlabel">
                        <span>Announcement Type<span className="mandatoryField">*</span></span>
                      </Form.Label>
                      <Form.Select
                        value={annoucementType}
                        onChange={handleSelectChange} // Use the handler to update state
                        isInvalid={!!anncoumentTypeError}
                        disabled={enableId}
                      >  <option value="" hidden></option>
                        {lovtype && lovtype.map((d) => (
                          <option key={d.id} value={d.id}>
                            {d.stxt}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {anncoumentTypeError}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="approval_fields1">
                    <Form.Group className="mb-2" controlId="NOC_Approval_Status">
                      <Form.Label className="formlabel">
                        <span>Category<span className="mandatoryField">*</span></span>
                      </Form.Label>
                      <Form.Select
                        value={categoryValue}
                        onChange={handleCategoryType} // Use the handler to update state
                        isInvalid={!!categoryError}
                      >  <option value="" hidden></option>
                        {category && category.map((d) => (
                          <option key={d.id} value={d.id}>
                            {d.englishname}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {categoryError}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <div className="comboflex">
                  <div className="districtQuota1">
                    <Form.Group className="mb-2" controlId="city_state">
                      <Form.Label className="formlabel">
                        <span>
                          Start Date<span className="mandatoryField">*</span>
                        </span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        isInvalid={!!startDateError}
                      />
                      <Form.Control.Feedback type="invalid">
                        {startDateError}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="districtQuota1">
                    <Form.Group className="mb-2" controlId="city_city">
                      <Form.Label className="formlabel">
                        <span>
                          End Date<span className="mandatoryField">*</span>
                        </span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        isInvalid={!!endDateError}
                      />
                      <Form.Control.Feedback type="invalid">
                        {endDateError}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="approval_fields1">
                    <Form.Group
                      className="mb-2"
                      controlId="NOC_Approval_Status"
                    >
                      <Form.Label className="formlabel">
                        <span>Status<span className="mandatoryField">*</span></span>
                      </Form.Label>
                      <Form.Select
                        value={statusId}
                        onChange={handleStatusChange}
                        isInvalid={!!statusError}
                      ><option value="" hidden></option>
                        {lovstatus && lovstatus.map((d, index) => (
                          <option key={d.id} value={d.id}>
                            {d.stxt}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {statusError}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <div className="comboflex">
                  <div className="districtQuota2">
                    <Form.Group className="mb-2" controlId="city_country">
                      <Form.Label className="formlabel">
                        <span>
                          Title
                          <span className="mandatoryField">*</span>
                        </span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        isInvalid={!!titleError}
                      />
                      <Form.Control.Feedback type="invalid">
                        {titleError}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  {/* <div className="approval_fields1">
                    <Form.Group
                      className="mb-2"
                      controlId="NOC_Approval_Status">
                      <Form.Label className="formlabel">
                        <span>Bullet In<span className="mandatoryField">*</span></span>
                      </Form.Label>
                      <Form.Select
                        value={bulletInId}
                        onChange={handleBulletInChange}
                        // isInvalid={!!statusError}
                      ><option value="" hidden></option>
                        {bulletInList && bulletInList.map((d, index) => (
                          <option key={d.id} value={d.id}>
                            {d.stxt}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {statusError}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div> */}
                </div>
                <div className="comboflex">
                  <div className="districtQuota2">
                    <Form.Group className="mb-2" controlId="city_country">
                      <Form.Label className="formlabel">
                        <span>
                          Message
                          <span className="mandatoryField">*</span>
                        </span>
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        type="text"
                        placeholder="Enter Message"
                        value={desc}
                        onChange={(e) => setdesc(e.target.value)}
                        isInvalid={!!msgError}
                      />
                      <Form.Control.Feedback type="invalid">
                        {msgError}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>

                {/* // tab */}
                <Tabs
                  className="dealer_tab"
                  defaultActiveKey="annoucementeditor"
                  id="fill-tab-example"
                  style={{ flex: "0 0 auto;" }}
                  fill
                >
                  <Tab eventKey="annoucementeditor" title="Annoucement">
                    <div
                      className="district_grid"
                      style={{ overflowY: "auto" }}
                    >
                      <div>

                        <div  style={{ height: "252px" }}>
                          <ReactQuill
                            ref={editorRef}
                            value={editorContent}
                            onChange={handleRichTextbox}
                            style={{ height: "100%" }}
                            modules={{
                              toolbar: [
                                [{ header: '1' }, { header: '2' }, { font: ['Noto Nastaliq Urdu', 'sans-serif'] }],
                                [{ list: 'ordered' }, { list: 'bullet' }],
                                ['bold', 'italic', 'underline'],
                                [{ script: 'sub' }, { script: 'super' }],
                                [{ align: [] }],
                                ['link', 'image'],
                                [{ color: [] }, { background: [] }],
                                ['blockquote'],
                                ['clean'],
                                [{ direction: 'rtl' }],
                              ],
                            }}

                            theme="snow"
                          />

                        </div>
                      </div>
                    </div>
                  </Tab>

                  <Tab eventKey="uploadfile" title="Attachment">
                    <div className="mainAttachmentTab">
                      <div
                        {...getRootProps()}
                        style={{
                          border: "2px dashed #ccc",
                          borderRadius: "10px",
                          margin: "5px 0",
                          overflow: "auto",
                          padding: "5px",
                          textAlign: "center",
                          cursor: "pointer",
                          height: "252px",
                          width: "70%",
                        }}
                      >
                        <input {...getInputProps()} />
                        {isDragActive ? (
                          <p>Drop the files here...</p>
                        ) : (
                          <>
                            {file.length > 0 ? (
                              <div className="attachmentContains">
                                <div className="fileContains">
                                  {file.map((fileItem, index) => (
                                    <div key={index} style={{ display: "flex", alignItems: "center" }}>
                                      <div className="innerContains" style={{ display: "flex", alignItems: "center" }}>
                                        <FaFileAlt size={25} />
                                        <span className="dragFileName" style={{ marginLeft: "10px" }}>{fileItem.name}</span>
                                        {/* <div style={{ margin: "0 10px" }}>{fileItem.name}</div> */}
                                      </div>
                                      <button
                                        style={{
                                          border: "none",
                                          backgroundColor: "transparent",
                                          color: "red",
                                          cursor: "pointer",
                                          position: "relative",
                                          bottom: "50px",
                                          right: "16px",
                                          width: "0px"
                                        }}
                                        onClick={(e) => {
                                          e.preventDefault()
                                          e.stopPropagation();
                                          const updatedFiles = file.filter((_, i) => i !== index);
                                          setFile(updatedFiles);
                                        }}
                                      >
                                        ✖
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ) : (
                              <div className="drag-drop-text">Drag and Drop here</div>
                            )}
                          </>
                        )}
                      </div>


                      {/* Display existing files */}
                      {/* {existingFiles.length > 0 && (
                        <div className="attachmentContains" style={{width : "30%"}}>
                          <div className="fileContains">
                            {existingFiles.map((file, index) => (
                              <div key={index}>
                                <div className="existingcontain">
                                  <FaFileAlt size={25} />
                                  <span style={{ margin: "10px 0" }}>{file.filename}</span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )} */}

                      {/* {existingFiles.length > 0 && (
                        <div className="file-attachments" style={{ width: "30%" }}>
                          <div className="file-list">
                            {existingFiles.map((file, index) => (
                              <div key={index} className="file-item">
                                <div className="file-icon-wrapper">
                                  <FaFileAlt size={25} />
                                </div>
                                <span className="file-name">{file.filename}</span>
                               
                              </div>
                              
                            ))}
                          </div>
                          
                        </div>
                      )} */}
                      {/* working{existingFiles.length > 0 && (
                        <>
                          <div></div>
                          <div className="file-attachments" style={{ width: "30%", overflow: "auto", maxHeight: "288px" }}>
                            <div className="file-list">
                              {existingFiles.map((file) => (
                                <div key={file.id} className="file-item" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                  <div className="file-icon-wrapper" style={{ display: "flex", alignItems: "center" }}>
                                    <FaFileAlt size={25} />
                                    <span className="file-name" style={{ marginLeft: "10px" }}>{file.filename}</span>
                                  </div>
                                  <FaTimes
                                    size={20}
                                    style={{ cursor: "pointer", color: "red" }}
                                    onClick={() => handleDelete(file.id)}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </>
                      )} */}

                      {existingFiles.length > 0 && (
                        <>
                          <div></div>
                          <div
                            className="file-attachments"
                            style={{ width: "30%", overflow: "auto", maxHeight: "288px" }}
                          >
                            <div className="file-list">
                              {existingFiles.map((file) => (
                                <div
                                  key={file.id}
                                  className="file-item"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div
                                    className="file-icon-wrapper"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => handleOpenDriveFile(file)}
                                  >
                                    <FaFileAlt size={25} />
                                    <span className="file-name" style={{ marginLeft: "10px" }}>
                                      {file.filename}
                                    </span>
                                  </div>
                                  <FaTimes
                                    size={20}
                                    style={{ cursor: "pointer", color: "red" }}
                                    onClick={() => handleDelete(file.id)}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </Tab>


                </Tabs>
              </div>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="modalbutton"
              variant="outline-success"
              onClick={handleCloseModal}
            >
              Close
            </Button>
            <Button
              className="modalbutton"
              variant="outline-success"
              onClick={addDataToTable}
            >
              {selectedIndex !== null ? "Update" : "Save"}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      <div className="parent_table">
        <div className="table-container">
          <Table striped bordered hover size="sm">
            <thead>
              <tr className="tb-heading">
                <th className="col-sm-1">Actions</th>
                <th className="col-sm-1">S.No</th>
                <th className="col-sm-1">Code</th>
                <th className="col-sm-1">Title</th>
                <th className="col-sm-1">Annoucement Type</th>
                <th className="col-sm-1">Status</th>
                <th className="col-sm-1">Start Date</th>
                <th className="col-sm-1">End Date</th>
              </tr>
              <tr className="tb-heading">
                <th></th>
                <th></th>
                <th>
                  <input type="text" className="table-filter" />
                </th>
                <th>
                  <input type="text" className="table-filter" />
                </th>
                <th>
                  <input type="text" className="table-filter" />
                </th>
                <th>
                  <input type="text" className="table-filter" />
                </th>
                <th>
                  <input type="text" className="table-filter" />
                </th>
                <th>
                  <input type="text" className="table-filter" />
                </th>
              </tr>
            </thead>
            <tbody>
              {currentEntries.map((district, index) => {
                const cumulativeIndex = indexOfFirstEntry + index + 1;
                return (
                  <tr className="tb-sub" key={cumulativeIndex}>
                    <td>
                      <div className="tdcol">
                        <Button
                          className="bn"
                          onClick={() => openUpdateModal(index)}
                        >
                          <FaEdit />
                        </Button>
                        <Button
                          className="bn"
                          onClick={() => deleteDataFromTable(district.id)}
                        >
                          <MdDelete />
                        </Button>
                      </div>
                    </td>
                    <td>{cumulativeIndex}</td>
                    <td>{district.typeid}</td>
                    <td>{district.stxt}</td>
                    <td>{district.stxtType}</td>
                    <td>{district.stype}</td>
                    <td>{district.startdate}</td>
                    <td>{district.enddate}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default NewsMagazine;
